import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
} from "@material-ui/core";
import { GridRowId } from "@material-ui/data-grid";
import { useState, useEffect, useReducer } from "react";
import en from "../../../lang/en-us";
import { connect } from "react-redux";
import { CustomRadio } from "../../../lib/CustomRadio";
import { TableColumn, TableWithCollapse } from "../../../lib/DataTable";
import { useTableWithCollapse } from "../../../lib/DataTable/customHooks";
import { sendPhoneOTP, updateDividend } from "../../../store/actions/nct";
import { getPortfolio } from "../../../store/actions/portfolio";
import { RootStateType } from "../../../store/reducers";
import { SCHEMES_RESPONSE } from "../../../store/types/portfolio";
import {
  EQUITY,
  LIQUID,
  DEBT,
  OTHER,
  OTP_ACTIONS,
} from "../../../utils/constants";
import {
  maskMobileNumber,
  getMatchAndUnMatchedFunds,
} from "../../../utils/utilityFunctions";
import NoFoliosFound from "../NoFoliosFound";
import { BackArrow } from "../UpdateNominee/SelectedFolios";
import {
  fundsByLienFlag,
  getDividendFilteredData,
  portfoliosByDividend,
  portfoliosByIdcwStatus,
  portfoliosByIdcwStatusNew,
  portfoliosByModeOfHolding,
  portfoliosByPayout,
  portfoliosByReinvestment,
  portfoliosByTransactionResource,
} from "../portfolios/utils";
import { groupFilteredData } from "../utils";
import CustomizedSelect from "../transactions/customizedSelect";
import { useMobileEmailFilter } from "../useMobileEmailFilter";

const PAYOUT_TO_REINVEST = "payout-to-reinvest";
const REINVEST_TO_PAYOUT = "reinvest-to-payout";
export interface DividendTableRowType extends SCHEMES_RESPONSE {
  id?: GridRowId;
  isDisabled?: boolean;
}

const { common, dashboard } = en;

const MenuList = [
  {
    label: dashboard.ChangeDividend.payoutToReinvest,
    value: PAYOUT_TO_REINVEST,
  },
  {
    label: dashboard.ChangeDividend.reinvestToPayout,
    value: REINVEST_TO_PAYOUT,
  },
];

const columns: TableColumn[] = [
  { field: "folio", headerName: "Folio", width: 150 },
  {
    field: "id",
    headerName: "Scheme Name",
    valueGetter: ({ row }) => `${row?.amcName}-${row?.schemeName}`,
    width: 350,
    filterBy: true,
    filterHeader: "Fund House",
    filterKey: "amcName",
  },
  { field: "investorName", headerName: "Primary Holder", width: 200 },
  {
    field: "mobile",
    headerName: "Mobile Number",
    width: 220,
    valueGetter: ({ row }) => maskMobileNumber(row?.mobile),
  },
  {
    isFilter: true,
    field: "assetType",
    headerName: "Category",
    filterBy: true,
    renderStaticFilters: [EQUITY, LIQUID, DEBT, OTHER],
  },
];
function ChangeDividend(props: any) {
  const [rowData, setRowData] = useState<DividendTableRowType[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  // const { portfolios = {} } = props;
  // const { success: folioList = [] } = portfolios;
  const [folioList, setFolioList] = useState([]);
  const [dividendOption, setDividendOption] = useState<string | null>(
    "payout-to-reinvest"
  );

  const { filterState, setGroupFilterMap, filterDispatch } =
    useMobileEmailFilter(rowData);
  const { emailMobileKeys, currentKey, groupedFilterMap } = filterState;

  const {
    selectedRows,
    setSelectedRows,
    resetTable,
    resetFilters,
    tableColumns,
    tableRows,
    ...filters
  } = useTableWithCollapse<DividendTableRowType[]>({
    initialSelectionModal: [],
    rows: currentKey ? groupedFilterMap[currentKey] : rowData,
    columns,
    loading,
  });
  async function fetchPortfolio() {
    const { user_pan: pan = "", pekrn = "", token: brokercode = "" } = props;
    try {
      setLoading(true);
      const folioData = await props.getPortfolio({
        pan,
        pekrn,
        brokercode,
      });
      setFolioList(folioData?.success || []);
    } catch (err: any) {
      alert(err.message);
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    fetchPortfolio();
  }, []);

  useEffect(() => {
    resetTable();
    resetFilters();
  }, [dividendOption]);

  useEffect(() => {
    const filterBySchemeOption: Function[] = [
      dividendOption === PAYOUT_TO_REINVEST
        ? portfoliosByPayout
        : portfoliosByReinvestment,
    ];
    const dividendFilters: Function[] = [
      portfoliosByModeOfHolding,
      portfoliosByTransactionResource,
      // portfoliosByClosingBalance,
      portfoliosByDividend,
      portfoliosByIdcwStatusNew,
      fundsByLienFlag,
    ];
    const schemeOptionsData = getDividendFilteredData(
      folioList,
      filterBySchemeOption
    );
    const data = getMatchAndUnMatchedFunds(
      dividendFilters,
      schemeOptionsData,
      true
    );
    setRowData(data);
  }, [folioList, dividendOption]);

  useEffect(() => {
    if (folioList?.length > 0) {
      // rowData can be empty based on filter and options.
      const groupedFilterMap = groupFilteredData(rowData);
      setGroupFilterMap(groupedFilterMap);
    }
  }, [rowData]);

  // clear selected rows on changing the value in the filter drop down
  useEffect(() => {
    setSelectedRows([]);
  }, [currentKey]);

  const handleFilterKeyChange = (e: any) => {
    filterDispatch({
      type: "SET_FILTER_KEY",
      payload: e.target.value,
    });
  };

  const handleSubmit = async () => {
    try {
      const email = selectedRows[0].email,
        mobile = selectedRows[0].mobile;
      const pan = props.investorData.PAN;
      const data = selectedRows.map((ele: DividendTableRowType) => {
        return {
          amc: ele.amc,
          amc_name: ele.amcName,
          folio: String(ele.folio),
          schemeCode: ele.schemeCode,
          schemeName: ele.schemeName,
          currentIdcwOption: dividendOption === PAYOUT_TO_REINVEST ? "D" : "R",
          newIdcwOption: dividendOption === PAYOUT_TO_REINVEST ? "R" : "D",
        };
      });
      let payload = {
        email,
        mobile,
        distributor_id: props.token,
        pan,
        data,
        pekrn: "",
      };
      let res = await props.updateDividend(payload);
      if (res.status === 201) {
        props.history.replace("/new-transaction/nct-type/success", {
          state: {
            succesMessage: res.message,
          },
        });
      }
    } catch (err: any) {
      alert(err.message);
    }
  };

  return (
    <div className="curved-bg">
      <BackArrow history={props.history} />
      <h5 style={{ marginLeft: "5px" }}>Change of IDCW</h5>
      {dividendOption && rowData.length > 0 && currentKey && (
        <div
          className="appbar-div dual-margin input-name-responsive"
          style={{ display: "flex", gap: "1%" }}
        >
          <div
            className="input-name input-name-sizing-responsive"
            style={{ alignItems: "center", display: "flex", marginBottom: "0" }}
          >
            Select Email-Mobile Combination
          </div>
          <CustomizedSelect
            handleChange={handleFilterKeyChange}
            value={currentKey}
            emailStyle={true}
          >
            {emailMobileKeys &&
              emailMobileKeys.map((item) => (
                <MenuItem value={item} key={item}>
                  {item}
                </MenuItem>
              ))}
          </CustomizedSelect>
        </div>
      )}
      <div className="curved-bg-content curved-bg-table-outer">
        <div className="curved-bg-content-table">
          <CustomRadio
            extraClass="custom-radio desktop_mode"
            title={dashboard.ChangeDividend.radioHeading}
            name="select-dividend"
            list={MenuList}
            selectedValue={dividendOption}
            handleRadioChange={(value: string) => setDividendOption(value)}
          />
          <FormControl variant="filled" className="mobile_mode">
            <InputLabel id="change-dividend-option-label">
              {dashboard.ChangeDividend.radioHeading}
            </InputLabel>
            <Select
              labelId="change-dividend-option-label"
              id="change-dividend-option"
              value={dividendOption}
              onChange={(e: any) => setDividendOption(e.target.value)}
            >
              {MenuList.map((item) => (
                <MenuItem key={item.label} value={item.value}>
                  {item.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {!!dividendOption && (
            <>
              <h5> {dashboard.ChangeDividend.ChangeDividendInfo}</h5>
              {(!!loading || tableRows.length) && currentKey ? (
                <TableWithCollapse
                  rows={tableRows}
                  columns={tableColumns}
                  isRowSelectable={(params) =>
                    params.row.isDisabled && currentKey?.length > 0
                      ? false
                      : true
                  }
                  selectedRows={selectedRows}
                  setSelectedRows={setSelectedRows}
                  toolTipTextGetter={({ row }) =>
                    row.isDisabled && row.lienUnitsFlag === "Y"
                      ? dashboard.ChangeDividend.noSelectLeinUnits
                      : row.isDisabled && currentKey?.length > 0
                      ? dashboard.ChangeDividend.toolTip.info1
                      : currentKey?.length == 0
                      ? common.invalidEmailMobileNCT
                      : ""
                  }
                  toolTipEnabled
                  checkBoxEnabled
                  resetFilters={resetFilters}
                  {...filters}
                />
              ) : (
                <NoFoliosFound info={"No Folios Found"} />
              )}
              {/* <FaqLink section={IDCW_OPTION} history={props.history} /> */}
            </>
          )}
        </div>

        {!!dividendOption && (
          <div className="curved-bg-content-inner-bottom">
            {!!rowData.length && (
              <div className="table-submit">
                <Button
                  className="customBtn"
                  disabled={!selectedRows.length}
                  onClick={handleSubmit}
                >
                  {dashboard.ChangeDividend.buttonText}
                </Button>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default connect(
  ({ authReducer, portfolio, investor }: RootStateType) => ({
    ...authReducer,
    ...portfolio,
    ...investor,
  }),
  { updateDividend, getPortfolio, sendPhoneOTP }
)(ChangeDividend);
